//  initialAPP
export const HOME_INITIAL_APP = 'HOME_INITIAL_APP';
